import React from "react";
import PropTypes from "prop-types";

const EditorTextoDecoratorDinamico = NomeTag => {
  const DecoratorDinamico = ({ contentState, entityKey, children }) => {
    const entityData = contentState.getEntity(entityKey).getData();
    const attributes = entityData.attributes || entityData;

    const propsFinais = {
      ...attributes,
      href: attributes.href || entityData.href || entityData.url,
    };

    return <NomeTag {...propsFinais}>{children}</NomeTag>;
  };
  DecoratorDinamico.propTypes = {
    contentState: PropTypes.object,
    entityKey: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  };

  return DecoratorDinamico;
};

EditorTextoDecoratorDinamico.propTypes = {
  NomeTag: PropTypes.string.isRequired,
};

export default EditorTextoDecoratorDinamico;
